/* LUNA collection — C2/C6, layouts per D35 (revised to Liv's sketch).
   Two filter layouts, chosen in the section settings:
   - band (default): one pill per filter GROUP across the top; each opens a dropdown
   - drawer: the original right slide-out behind a "Sort + Filter" pill
   Both share the same form + Section Rendering API swap.
   D93: the band layout ALSO renders the drawer, opened by a mobile-only
   trigger — so phones get one Filter button instead of a swipe strip. That
   means a section can hold TWO filter forms (band + drawer); every form is
   bound, apply() reads whichever form changed, and render() syncs them all
   by index.
   Notes:
   - the band's sort <select> is form-ASSOCIATED (form attribute); change events
     bubble through the DOM tree, so it needs its own listener.
   - a filter change re-renders the form, which would close the open dropdown —
     render() remembers which dropdown was open (data-dd-id) and reopens it. */
(function(){
  if(window.__lunaCollection) return; window.__lunaCollection = true;

  function init(root){
    if(root.__luna) return; root.__luna = true;
    var sectionId = root.dataset.sectionId;
    var forms = Array.prototype.slice.call(root.querySelectorAll('[data-luna-filter-form]'));
    var results = root.querySelector('[data-luna-results]');
    var countEl = root.querySelector('[data-luna-count]');
    var pills = root.querySelector('[data-luna-pills]');

    /* ---- drawer (drawer layout, and the band layout's mobile filter) ---- */
    var drawer = root.querySelector('[data-luna-drawer]');
    var scrim = root.querySelector('[data-luna-scrim]');
    var openBtns = Array.prototype.slice.call(root.querySelectorAll('[data-luna-open]'));
    var lastFocus = null;
    function openDrawer(){
      lastFocus = document.activeElement;
      root.classList.add('is-drawer-open');
      drawer.removeAttribute('inert');
      openBtns.forEach(function(b){ b.setAttribute('aria-expanded','true'); });
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('button, input, a');
      if(first) first.focus();
    }
    function closeDrawer(){
      root.classList.remove('is-drawer-open');
      drawer.setAttribute('inert','');
      openBtns.forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      document.body.style.overflow = '';
      if(lastFocus) lastFocus.focus();
    }
    if(drawer){
      openBtns.forEach(function(b){ b.addEventListener('click', openDrawer); });
      root.querySelectorAll('[data-luna-close]').forEach(function(b){ b.addEventListener('click', closeDrawer); });
      if(scrim) scrim.addEventListener('click', closeDrawer);
    }

    /* ---- band dropdowns ---- */
    function closeDDs(except){
      root.querySelectorAll('[data-luna-dd][aria-expanded="true"]').forEach(function(t){
        if(t !== except) t.setAttribute('aria-expanded','false');
      });
    }
    root.querySelectorAll('[data-luna-dd]').forEach(function(t){
      t.addEventListener('click', function(){
        var open = t.getAttribute('aria-expanded') === 'true';
        closeDDs(t);
        t.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    /* document-level handlers only once per section root */
    if(!root.__lunaDoc){
      root.__lunaDoc = true;
      document.addEventListener('click', function(e){
        if(!e.target.closest('.luna-col__dd')) closeDDs();
      });
      document.addEventListener('keydown', function(e){
        if(e.key !== 'Escape') return;
        closeDDs();
        if(root.classList.contains('is-drawer-open')){
          var d = root.querySelector('[data-luna-drawer]');
          if(d){
            root.classList.remove('is-drawer-open');
            d.setAttribute('inert','');
            document.body.style.overflow = '';
          }
        }
      });
    }

    /* drawer accordion groups */
    root.querySelectorAll('[data-luna-group-toggle]').forEach(function(t){
      t.addEventListener('click', function(){
        t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });

    /* keep dev-preview template params (?view=claude) on every rendered URL */
    function keepView(url){
      var view = new URLSearchParams(location.search).get('view');
      if(!view) return url;
      var u = new URL(url, location.origin);
      if(!u.searchParams.get('view')) u.searchParams.set('view', view);
      return u.pathname + u.search;
    }

    function render(url){
      url = keepView(url);
      var openDD = root.querySelector('[data-luna-dd][aria-expanded="true"]');
      var openId = openDD ? openDD.dataset.ddId : null;
      root.classList.add('is-loading');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
        .then(function(r){ return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newResults = doc.querySelector('[data-luna-results]');
          var newForms   = doc.querySelectorAll('[data-luna-filter-form]');
          var newCount   = doc.querySelector('[data-luna-count]');
          var newPills   = doc.querySelector('[data-luna-pills]');
          var newSort    = doc.querySelector('[data-luna-sort]');
          var curSort    = root.querySelector('[data-luna-sort]');
          if(newResults) results.innerHTML = newResults.innerHTML;
          forms.forEach(function(f, i){ if(newForms[i]) f.innerHTML = newForms[i].innerHTML; });
          if(newPills && pills) pills.innerHTML = newPills.innerHTML;
          if(newCount && countEl) countEl.textContent = newCount.textContent;
          if(newSort && curSort) curSort.value = newSort.value;
          history.replaceState({}, '', url);
          if(window.lunaCardScan) window.lunaCardScan(results);
          if(window.lunaReveal)   window.lunaReveal(results);
          var wasOpen = root.classList.contains('is-drawer-open');
          root.__luna = false; init(root);
          if(wasOpen) root.classList.add('is-drawer-open');
          if(openId){
            var t = root.querySelector('[data-luna-dd][data-dd-id="' + openId + '"]');
            if(t) t.setAttribute('aria-expanded','true');
          }
        })
        .catch(function(){ window.location.href = url; })
        .finally(function(){ root.classList.remove('is-loading'); });
    }

    function apply(srcForm){
      if(!srcForm) return;
      var params = new URLSearchParams(new FormData(srcForm));
      var clean = new URLSearchParams();
      params.forEach(function(v,k){ if(v !== '') clean.append(k,v); });
      var qs = clean.toString();
      render(root.dataset.url + (qs ? '?' + qs : ''));
    }

    forms.forEach(function(f){
      f.addEventListener('change', function(){ apply(f); });
      f.addEventListener('submit', function(e){ e.preventDefault(); });
    });
    /* form-associated sort select lives outside the form element */
    root.querySelectorAll('[data-luna-sort]').forEach(function(sel){
      sel.addEventListener('change', function(){ apply(forms[0]); });
    });

    root.querySelectorAll('[data-luna-clear]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); render(root.dataset.url); });
    });
    root.querySelectorAll('[data-luna-remove]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); render(b.dataset.lunaRemove); });
    });
  }

  function scan(){ document.querySelectorAll('[data-luna-collection]').forEach(init); }
  document.addEventListener('DOMContentLoaded', scan);
  if(document.readyState !== 'loading') scan();
  document.addEventListener('shopify:section:load', scan);
})();